import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop", "button"]

  connect() {
    this.closeOnNavigate = () => this.close()
    document.addEventListener("turbo:before-visit", this.closeOnNavigate)
    this.onResize = () => this.syncViewport()
    window.addEventListener("resize", this.onResize)
    this.syncViewport()
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.closeOnNavigate)
    window.removeEventListener("resize", this.onResize)
    document.body.classList.remove("dashboard-nav-open")
  }

  toggle() {
    const open = this.buttonTarget.getAttribute("aria-expanded") === "true"
    this.setOpen(!open)
  }

  close() {
    this.setOpen(false)
  }

  setOpen(open) {
    if (this.desktopViewport()) {
      this.panelTarget.hidden = false
      if (this.hasBackdropTarget) this.backdropTarget.hidden = true
      this.buttonTarget.setAttribute("aria-expanded", "false")
      this.element.classList.remove("dashboard-layout--nav-open")
      document.body.classList.remove("dashboard-nav-open")
      return
    }

    this.panelTarget.hidden = !open
    if (this.hasBackdropTarget) this.backdropTarget.hidden = !open
    this.buttonTarget.setAttribute("aria-expanded", String(open))
    this.element.classList.toggle("dashboard-layout--nav-open", open)
    document.body.classList.toggle("dashboard-nav-open", open)
  }

  syncViewport() {
    if (this.desktopViewport()) {
      this.setOpen(false)
      this.panelTarget.hidden = false
      return
    }

    if (this.buttonTarget.getAttribute("aria-expanded") !== "true") {
      this.panelTarget.hidden = true
    }
  }

  desktopViewport() {
    return window.matchMedia("(min-width: 768px)").matches
  }
}
